module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting-view"
  }, [_c('div', {
    staticClass: "appmsg_input_area"
  }, [_c('div', {
    attrs: {
      "id": "submitContent"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "top",
      "label-width": "80px"
    }
  }, [_c('div', {
    staticClass: "content-padded"
  }, [_c('div', {
    staticClass: "content-padded appmsg_edit_highlight_area",
    staticStyle: {
      "height": "200px"
    }
  }, [_c('h3', {
    staticClass: "header-title"
  }, [_vm._v("发布样式编辑")]), _vm._v(" "), _c('div', {
    staticClass: "header_tips"
  }, [_vm._v("封面小图片 "), _c('span', {
    staticClass: "form-text-tip"
  }, [_vm._v("建议尺寸：200像素 * 200像素")])]), _vm._v(" "), _c('el-form-item', [_c('div', [_c('el-button', {
    on: {
      "click": _vm.addThumbPreview
    }
  }, [_vm._v("从图片库选择")])], 1), _vm._v(" "), (_vm.form.image_url) ? _c('div', {
    staticClass: "cover_preview",
    style: ({
      backgroundImage: 'url(' + (_vm.form.image_url ? _vm.wximageurl + _vm.form.image_url : '') + ')'
    })
  }) : _vm._e()])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "height": "80px"
    },
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "height": "80px"
    },
    attrs: {
      "label": "作者"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入作者"
    },
    model: {
      value: (_vm.form.author),
      callback: function($$v) {
        _vm.$set(_vm.form, "author", $$v)
      },
      expression: "form.author"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文章类目选择"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.category_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "category_id", $$v)
      },
      expression: "form.category_id"
    }
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('el-option', {
      key: item.category_id,
      attrs: {
        "label": item.category_name,
        "value": item.category_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择标签"
    },
    model: {
      value: (_vm.form.tags),
      callback: function($$v) {
        _vm.$set(_vm.form, "tags", $$v)
      },
      expression: "form.tags"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content",
    staticStyle: {
      "height": "380px"
    }
  }, [_c('vue-html5-editor', {
    ref: "editor",
    attrs: {
      "content": _vm.form.viewcontent,
      "height": 360
    },
    on: {
      "change": _vm.updateContent
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "appmsg_tpl_area"
  }, [_c('div', {
    staticClass: "appmsg_tpl_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "appmsg_container_bd"
  }, [_c('ul', {
    staticClass: "tpl_list",
    attrs: {
      "id": "js_media_list"
    }
  }, [_c('li', {
    staticClass: "tpl_item img",
    on: {
      "click": _vm.addImgPreview
    }
  }, [_c('i', {
    staticClass: "iconfont icon-image"
  }), _vm._v("图片\n          ")])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.thumbDialog,
      "sc-status": _vm.isGetThumb
    },
    on: {
      "chooseImg": _vm.pickThumb,
      "closeImgDialog": _vm.closeThumbDialog
    }
  }), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "setting-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appmsg_container_hd"
  }, [_c('h4', {
    staticClass: "appmsg_container_title"
  }, [_vm._v("多媒体")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30b31641", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30b31641"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/article/editor.vue
// module id = 2592
// module chunks = 0